import { StyleSheet } from 'aphrodite';
import { eightAmColor, eightAmColorTranslucent } from '../brandColors';

export const styleSheet = StyleSheet.create({
	ctaButton: {
		background: eightAmColorTranslucent,
		border: 'none',
		boxShadow: 'none',
		color: eightAmColor,
		fontWeight: 400,
		marginTop: 20,
	},
	integrationTitle: {
		color: eightAmColor,
	},
	logo: {
		border: `1px solid ${eightAmColor}`,
		borderRadius: 12,
		height: 40,
		marginRight: -10,
		objectFit: 'contain',
		padding: 4,
		width: 40,
	},
});
